import { PlatePair } from '@paragon/contract-library';

import { getActiveComponentDesign } from '../selectors/getActiveComponentDesignSelector';
import { upsertPlatePairs } from '../slices/componentDesignsSlice';
import { analyzeSelectedPlates } from '../slices/livePlatingSlice';
import { loadAdditionalPlatePairInformation } from './loadActions';
import { AsyncThunkActionVoid } from './thunkActions';

export const changePlatePairs =
  (componentDesignGuid: string, platePairs: PlatePair[]): AsyncThunkActionVoid =>
  async (dispatch) => {
    await dispatch(loadAdditionalPlatePairInformation(platePairs));
    dispatch(upsertPlatePairs({ componentDesignGuid, platePairs, lockPlating: true }));
    await dispatch(analyzeSelectedPlates());
  };

export const changePlatePairAngle =
  (angle: number, ...platePairGuids: string[]): AsyncThunkActionVoid =>
  async (dispatch, getState) => {
    const state = getState();

    const componentDesign = getActiveComponentDesign(state)!;
    const editedPlatePairs = componentDesign.component.platePairs
      .filter((platePair) => platePairGuids.includes(platePair.guid))
      .map((platePair) => ({ ...platePair, angleZ: angle }));

    dispatch(
      upsertPlatePairs({ componentDesignGuid: componentDesign.guid, platePairs: editedPlatePairs, lockPlating: true }),
    );
    await dispatch(analyzeSelectedPlates());
  };
